module.exports = __webpack_public_path__ + "img/270.9d010b63.png";